module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-3.5bf371f0.jpg";